import ChangeInMetric from './ChangeInMetric';

export default ChangeInMetric;
